import { Comune } from './comune';
import { Model } from './model';
import { Regione } from './regione';
import { ZonaGeografica } from './zona-geografica';

export class Provincia extends Model {
    static apiUrl: string = "province";

    nome: string;
    codice: string;
    regione: Regione;
    zona_geografica: ZonaGeografica;
    comuni: Comune[];

    deserialize(input: any): Provincia {
        let retV: Provincia = new Provincia();

        retV = super.deserialize(input) as Provincia;

        if (input?.comuni) {
            retV.comuni = input.comuni.map(m => new Comune().deserialize(m));
        }

        if (input?.regione) {
            retV.regione = new Regione().deserialize(input.regione);
        }
        if (input?.zona_geografica) {
            retV.zona_geografica = new ZonaGeografica().deserialize(input.zona_geografica);
        }

        return retV;
    }

}
